module.exports = __webpack_public_path__ + "static/flight-directed-aed6e913da8a206145ff0c2f34e16cb2.svg";